var map = {
	"./About.svelte": [
		"./src/views/About.svelte",
		"src_views_About_svelte"
	],
	"./ComingSoon.svelte": [
		"./src/views/ComingSoon.svelte",
		"src_views_ComingSoon_svelte"
	],
	"./Contact.svelte": [
		"./src/views/Contact.svelte",
		"src_views_Contact_svelte"
	],
	"./PrivacyPolicy.svelte": [
		"./src/views/PrivacyPolicy.svelte",
		"src_views_PrivacyPolicy_svelte"
	],
	"./Terms.svelte": [
		"./src/views/Terms.svelte",
		"src_views_Terms_svelte"
	],
	"./Welcome.svelte": [
		"./src/views/Welcome.svelte",
		"src_views_Welcome_svelte"
	],
	"./auth/404.svelte": [
		"./src/views/auth/404.svelte",
		"src_views_auth_404_svelte"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/views lazy recursive ^\\.\\/.*\\.svelte$";
module.exports = webpackAsyncContext;